import {
    getServerTexts as getTexts,
    initTexts,
    texts as localization
} from '../../Localization/texts';

export const entity = 'UI_AUTOMATIONS';

export const en = {
    menu_trigger: 'Automations',
    menu_macro: 'Macros',
    menu_deleteMessage: 'The macro will be deleted, and we will not be able to',
    menu_deleteYes: 'Yes',
    menu_deleteNo: 'No',
    menu_subMenuBottomTitle: 'Macros',
    menu_recordMacro: 'Record Macro',
    msg_startRecursiveMacro: 'Macro XXX will now run up to X times.',
    footer_recordingTooltip: 'Recording',
    footer_stopTooltip: 'Stop recording',

    menu_macroHelp:
        'A macro will help you automate a sequence of actions, and perform them repeatedly with the click of a button. \n Here you can run an existing macro, or record and save a new one. \n\n You can find more information on macro options in the User Interface Guide. (The UIG is found under the Help icon on the homepage.)',
    dlg_sameKeyMessage: 'Shortcut keys Alt+X run macro XXX.',
    dlg_sameKeyMessage2: 'Shortcut Alt+X runs macro XXX. Choose a different',
    dlg_saveBtn: 'Save',

    dlg_yes: 'yes',
    dlg_no: 'no',
    dlg_accept: 'OK',
    dlg_cancel: 'Cancel',
    dlg_title: 'Save New Macro',
    dlg_inputNamePlaceholder: 'Macro X',
    dlg_repeatTitle: 'Repeat',
    dlg_help:
        'Here you can choose whether the macro’s action will repeat itself according to the highest possible number.',
    dlg_repeatOptionNoRepeat: 'Does not repeat',
    dlg_repeatOptionAll: "All form's records",
    dlg_repeatOptionConst: 'By constant',
    dlg_repeatOptionTimes: 'times',
    dlg_constOptionearnMsgContent:
        'The number of reruns is limited to X, as defined by the system administrator in the RECURSIVEMACRO constant.',
    dlg_constOptionearnMsgBtn: 'Ok',
    dlg_footerSave: 'Start Recording',
    dlg_footerSaveExecute: 'Save & Run',
    dlg_saveSuccessMsg: 'We saved the changes for macro XXX.',
    dlg_unsavedMsgContent: 'The macro has not been saved. Leave anyway?',
    dlg_unsavedMsgYesBtn: 'Yes',
    dlg_unsavedMsgNoBtn: 'No',
    dlg_editMacroTitle: 'Edit Macro XXX',
    dlg_macroSettings: 'Macro Settings',
    saveMacroMsg: 'We saved the sequence of actions for macro XXX.',
    footer_stopMacroTooltip: 'End the Macro',
    footer_stopMacroMessage: "Stop the macro's automatic operation?",
    footer_macroAciveToolip: 'The macro is running now.',
    dlg_nameExistMsgContent: 'A macro with this name already exists.',
    dlg_nameExistMsgContentNoPremissions: 'A macro with this name already exists in the system.',
    dlg_inputNameLabel: 'Name',
    dlg_inputKeyLabel: 'Shortcut',
    dlg_saveSuccessNoKey: 'We saved the changes for macro XXX.',
    macro_dialog_start_recording_btn: 'Start recording',
    macro_dialog_name_label: 'Name',
    macro_dialog_shortcut_label: 'Shortcut',
    macro_dialog_repeat_label: 'Repeat',

    macro_recording_text: 'Recording',
    macro_stop_text: 'Stop',

    marco_submenu_record_button: 'Record Macro',
    macro_submenu_delete_lines: 'Delete lines',

    business_rules_option_title: 'Business Rules',
    autofill_rules_option_title: 'Autofill Rules',
    business_rules_dialog_title: 'Define Business Rules',
    new_label: 'New',
    report_btn_label: 'Report',
    search_placeholder: 'Search...',
    all_actions_label: 'All actions',
    error_action_title: 'Display error msg',
    assign_to_action_title: 'Assign to',
    warning_action_title: 'Warning msg',
    send_email_action_title: 'Send email',
    send_text_action_title: 'Send text msg',
    open_task_action_title: 'Open task',
    send_notification_action_title: 'Send notification',
    webhook_action_title: 'Webhook',
    user_verification_action_title: 'User verification',
    valid_for_label: 'Valid for',
    myself_label: 'Myself',
    all_users_label: 'All users',
    my_privilege_group_label: 'Users in my privilege group',
    spec_privilege_group_label: 'A specific privilege group',
    valid_for_filter_privilege_group: 'Specific privilege group',
    valid_for_filter_user: 'Specific user',
    specific_user_label: 'A specific user',
    specific_user_option_text: 'A specific user',
    updated_by_label: 'Updated by',
    active_label: 'Active',
    inactive_label: 'Inactive',
    applied_filters_label: 'Applied filters',
    dnd_label: 'Drag & drop',
    when_label: 'When',
    then_label: 'Then',
    set_label: 'Set',
    rule_description_label: 'Rule Description',
    rule_description_placeholder: 'Add a description to your rule',
    rule_number_label: 'Rule Number',
    rule_valid_for_label: 'Valid for',
    is_active_tooltip: 'Set as inactive',
    is_inactive_tooltip: 'Set as active',
    edit_tooltip: 'Edit',
    duplicate_tooltip: 'Duplicate',
    delete_tooltip: 'Delete',
    empty_state_business_rule_title: 'Business rules will appear here.',
    action_label: 'Action',
    empty_search_title: 'We did not find results that match your search',
    empty_search_text: 'Try to find it with another search word',
    empty_state_business_rule_text: 'Click the New button to create a business rule.',
    empty_state_autofill_rule_text: 'Click the New button to create a new rule',
    empty_state_autofill_rule_title: 'Your autofill rules will appear here”',
    rules_dialog_help:
        'Define rules to shorten and automate your workflow. Define conditions to have emails or push notifications sent automatically, have messages appear in the system, require user verification for a certain action, and more. \n' +
        '\n' +
        'See the User Interface Guide for more information.',
    autofill_rules_dialog_help:
        'Automate your work processes by creating rules that will automatically update your data, quickly and easily.\n' +
        'According to the conditions you define, data in fields will update automatically. No need to update data manually (e.g., enter a customer number, and the Details field fills in a relevant note pertaining to the customer).\n' +
        'For more information, see the User Interface Guide.',
    single_autofill_rule_help:
        'Here you can create or edit existing rules. On the left “When” section, set the condition. On the right “Then” section, set the rule.',
    single_business_rule_help:
        'Here you can create or edit existing business rules. On the left “When” section, set the rule and the condition for the rule. On the right “Then” section, set the action that will take place if conditions are met.',
    single_rule_active_label: 'Active',
    rule_dd_placeholder: 'Select…',
    condition_if_label: 'If',
    condition_of_label: 'Of',
    autofill_source_field: 'After updating',
    autofill_condition_set: 'Set in the field',
    autofill_condition_as: 'As',
    condition_function_label: 'Function',
    condition_value_label: 'Value',
    function_dialog_help:
        'Here you can add expressions to your rule, instead of fixed values. Choose to add fields, functions, or predefined expressions. \n' +
        '\n' +
        'See the User Interface Guide for more information.',
    function_dialog_title: 'Condition',
    function_dialog_input_placeholder: 'Enter a field, function, or predefined expression',
    function_dialog_tab_fields_label: 'Fields',
    function_dialog_tab_function_label: 'Function',
    function_icon_tooltip: 'Add expression',
    function_dialog_tab_predefinedEpx_label: 'Predefined Expression',
    operator_and_label: 'And',
    operator_or_label: 'Or',
    input_field_label: 'Field',
    input_message_label: 'Message',
    input_message_placeholder: 'Enter message',
    input_subject_label: 'Subject',
    input_subject_placeholder: 'Enter subject',
    attachment_label: 'Attachment',
    documents_label: 'Choose document',
    print_format_label: 'Using print format',
    html_group_label: 'HTML',
    doc_group_label: 'Doc',
    pdf_label: 'PDF',
    new_autofill_rule_dialog_title: 'Define Autofill Rule',
    apply_to_all_companies_label: 'In all companies?',
    cancel_btn_label: 'Cancel',
    add_new_condition_label: 'Add condition',
    select_placeholder: 'Select…',
    exit_without_saving_msg: 'Exit without saving your changes?',
    attach_as_pdf_label: 'Attach as PDF',
    attach_as_template_label: 'Template Document?',
    show_more_label: 'More',
    show_less_label: 'Show less',
    send_to_label: 'Send to',
    assign_to_label: 'Assign to',
    macro_sub_title: `Some changes were not saved.
    Continue?`,
    value_changes_label: 'changes',
    in_label: 'in the ',
    if_optional_label: 'If (optional)',
    wrong_exp_title: 'Priority Error',
    wrong_exp_text: 'Invalid condition.',
    no_options_text: 'No options...',
    ignoreCase: 'Ignore Case',
    search_from_start: 'Search From Start of Record',
    only_label: 'Only',
    select_user_placeholder: 'Select user...',
    select_group_placeholder: 'Select group...',
    general_choose_placeholder: 'Choose',
    rule_dialog_save: 'Save',
    delete_rule_title: 'Delete?',
    delete_rule_text: 'Are you sure you want to delete this rule?',
    delete_rule_confirm_label: 'Yes',
    delete_rule_decline_label: 'Cancel',
    email_field_placeholder: 'Enter email address',
    email_field_label: 'Email Address',
    add_email_label: 'Add',
    email_validation_error: 'Enter a valid email address.',
    old_email_template_label: 'Write',
    new_email_template_label: 'Email editor',
    autofill_card_field_label: 'field',
    user_verification_content:
        'Here you can define that when a user tries to update a field, they will receive a message requiring them to reenter their password.',
    english_lang_tab: 'English',
    hebrew_lang_tab: 'Hebrew',
    business_rule_error_title: 'Business rule',
    add_document: 'Add document',
    go_back_dialog_title: 'Before you leave,',
    go_back_dialog_content: 'Exit without saving your changes?',
    go_back_dialog_secondary_btn: 'Cancel',
    go_back_dialog_primary_btn: 'Yes',
    go_back_btn_tooltip: 'Back',
    general_automation_list_dialog_help:
        'Use these rules to shorten and automate your workflow. \n Here, view a list of your existing rules.\n Find a rule using filters or use the search box.\n  Edit, duplicate, or delete simply and easily.\n Click the New button to start creating rules.\n See the User Interface Guide for more information.',
    falls_between_and_operator_label: 'and',
    save_business_rule_btn_validation_tooltip: 'Fill in all mandatory fields.',
    save_autofill_rule_btn_validation_tooltip: 'Fill in all mandatory fields.',
    save_rule_valid_for_user_error: 'Choose a specific user for whom the rule is valid',
    save_rule_valid_for_group_error:
        'Choose a specific privilege group for which the rule is valid.',
    help_popover_title: 'Help',
    date_control_custom_label: 'Custom',
    date_control_placeholder: 'Select date'
};

export const he = {
    macro_sub_title: `חלק מהשינויים לא נשמרו.
    לְהַמשִׁיך?`,
    menu_trigger: 'אוטומציות',
    menu_macro: 'מאקרו',
    menu_deleteMessage: 'המאקרו ימחק ולא נוכל לשחזר אותו. למחוק בכל זאת?',
    menu_deleteYes: 'כן',
    menu_deleteNo: 'לא',
    menu_subMenuBottomTitle: 'מאקרו',
    msg_startRecursiveMacro: 'מאקרו "XXX" ייפעל עכשיו עד "X" פעמים.',
    footer_recordingTooltip: 'מקליט כרגע',
    footer_stopTooltip: 'לעצור את ההקלטה',

    dlg_yes: 'כן',
    dlg_no: 'לא',

    dlg_accept: 'אישור',
    dlg_cancel: 'ביטול',
    menu_macroHelp:
        'מאקרו יעזור לך להפוך סדרת פעולות שכיחות לאוטומטיות, ולבצע אותן בלחיצת כפתור אחת.     כאן אפשר להפעיל מאקרו קיים, או להקליט ולשמור חדש. עוד מידע על אפשרויות המאקרו במדריך לממשק משתמש (תחת אייקון העזרה בכותרת הראשית של פריוריטי).',

    dlg_sameKeyMessage: 'קיצור Alt+X מפעיל את מאקרו "XXX".',
    dlg_sameKeyMessage2: 'קיצור Alt+X מפעיל את מאקרו "XXX". יש לבחור קיצור אחר.',
    dlg_saveBtn: 'שמירה',
    menu_recordMacro: 'הקלטת מאקרו',
    dlg_title: 'מאקרו חדש',
    dlg_inputNamePlaceholder: 'מאקרו X',
    dlg_repeatTitle: 'חזרות',
    dlg_help:
        'כאן אפשר לבחור האם הפעולה של המאקרו תחזור על עצמה. האם הפעולה תתבצע על כל הרשומות המופיעות המסך, האם הפעולה תרוץ עד מספר הפעמים שהוגדר בקבוע המערכת, או מספר מדויק שתגדירו כאן. בכל מקרה, החזרה לעולם לא תעלה על מספר החזרות שהוגדר בקבוע. ',
    dlg_repeatOptionNoRepeat: 'ללא חזרה',
    dlg_repeatOptionAll: 'לכל הרשומות במסך',
    dlg_repeatOptionConst: '​לפי הקבוע',
    dlg_repeatOptionTimes: 'פעמים',
    dlg_constOptionearnMsgContent:
        'מספר החזרות יכול להיות עד X, בקבוע RECURSIVEMACRO על ידי מנהל/ת המערכת. כפי שהוגדר',
    dlg_constOptionearnMsgBtn: 'אישור',
    dlg_footerSave: 'תחילת הקלטה',
    dlg_footerSaveExecute: 'שמירה והפעלה',
    dlg_saveSuccessMsg: 'שמרנו את השינויים במאקרו "XXX".',
    dlg_unsavedMsgContent: 'המאקרו עדיין לא נשמר. לצאת בכל זאת?',
    dlg_unsavedMsgYesBtn: 'כן',
    dlg_unsavedMsgNoBtn: 'לא',
    dlg_editMacroTitle: 'עריכת מאקרו "XXX"',
    dlg_macroSettings: 'הגדרות המאקרו',
    saveMacroMsg: 'שמרנו את רצף הפעולות עבור "מאקרו XXX"',
    footer_stopMacroTooltip: 'הפסקת המאקרו',
    footer_stopMacroMessage: 'להפסיק את הפעולה האוטומטית של המאקרו?',
    footer_macroAciveToolip: 'המאקרו כרגע פעיל',
    dlg_nameExistMsgContent: 'במערכת כבר קיים מאקרו בשם הזה.',
    dlg_nameExistMsgContentNoPremissions:
        'במערכת כבר קיים מאקרו בשם זה (ואין לך אפשרות לשנות את הגדרותיו).',
    dlg_inputNameLabel: 'שם',
    dlg_inputKeyLabel: 'מקש קיצור',
    dlg_saveSuccessNoKey: 'שמרנו את השינויים במאקרו "XXX".',
    macro_dialog_start_recording_btn: 'Start recording',
    macro_dialog_name_label: 'Name',
    macro_dialog_shortcut_label: 'Shortcut',
    macro_dialog_repeat_label: 'Repeat',

    macro_recording_text: 'Recording',
    macro_stop_text: 'Stop',

    marco_submenu_record_button: 'הקלט מאקרו',
    macro_submenu_delete_lines: 'מחק שורות',

    business_rules_option_title: 'חוקים עסקיים',
    autofill_rules_option_title: 'חוקים למילוי אוטומטי',
    business_rules_dialog_title: 'הגדרת חוקים עסקיים',
    new_label: 'חדש',
    report_btn_label: 'דו”ח',
    search_placeholder: 'חיפוש…',
    all_actions_label: 'כל הפעולות',
    error_action_title: 'הצגת שגיאה',
    assign_to_action_title: 'הקצאה למשתמש',
    warning_action_title: 'הצגת אזהרה',
    send_email_action_title: 'שליחת אימייל',
    send_text_action_title: 'שליחת SMS',
    open_task_action_title: 'פתיחת משימה',
    send_notification_action_title: 'שליחת הודעת פוש',
    webhook_action_title: 'Webhook',
    user_verification_action_title: 'אימות משתמש',
    valid_for_label: 'החוק תקף',
    myself_label: 'לעצמי בלבד',
    all_users_label: 'לכל המשתמשים',
    my_privilege_group_label: 'משתמשים בקבוצת ההרשאות שלי',
    spec_privilege_group_label: 'משתמשים בקבוצת הרשאות מסוימת',
    specific_user_label: 'למשתמש',
    valid_for_filter_privilege_group: 'קבוצת הרשאות מסוימת',
    valid_for_filter_user: 'משתמש',
    specific_user_option_text: 'משתמש',
    updated_by_label: 'עודכן ע"י',
    active_label: 'פעיל',
    inactive_label: 'לא פעיל',
    applied_filters_label: 'סינונים שנבחרו',
    dnd_label: 'גרירה ושחרור',
    when_label: 'אם',
    then_label: 'אז',
    set_label: 'קבע',
    rule_number_label: 'מספר חוק',
    rule_description_label: 'תיאור חוק',
    rule_description_placeholder: 'רשמו תאור לחוק',
    rule_valid_for_label: 'תקף עבור',
    is_active_tooltip: 'לחצו כדי להשבית',
    is_inactive_tooltip: 'לחצו כדי להפעיל',
    edit_tooltip: 'עריכה',
    duplicate_tooltip: 'שכפול',
    delete_tooltip: 'מחיקה',
    empty_state_business_rule_title: 'כשיהיו חוקים עסקיים, הם יופיעו כאן',
    empty_state_business_rule_text: 'לחצו על הכפתור “חדש” כדי ליצור חוק עסקי',
    empty_state_autofill_rule_text: 'לחצו על הכפתור “חדש” כדי ליצור חוק למילוי אוטומטי.',
    empty_state_autofill_rule_title: 'החוקים שלך יופיעו כאן.',
    empty_search_title: 'אין נתונים המתאימים לחיפוש',
    empty_search_text: 'כדאי לבדוק את האיות שוב',
    rules_dialog_help:
        'הגדרת חוקים לקיצור תהליכי עבודה וניהולם אוטומטית. בהתאם לתנאים שתגדירו, אימיילים או הודעות פוש ישלחו אוטומטית, תוצג הודעה במערכת, משתמש יידרש לאימות נוסף בעת ביצוע פעולה מסוימת, ועוד. \n' +
        '\n' +
        'למידע נוסף ראו את מדריך לממשק משתמש.',
    autofill_rules_dialog_help:
        'כאן אפשר להגדיר אוטומציות לייעול תהליכי העבודה שלך באמצעות חוקים עסקיים. בהתאם לתנאים שתגדירו, תוצג הודעה במערכת, תישלח הודעת אימייל או הודעת פוש למובייל, תיפתח משימה, משתמש ייידרש לאימות נוסף בעת ביצוע פעולה מסוימת, ועוד.עוד מידע על חוקים עסקיים נמצא במדריך לממשק משתמש (תחת אייקון העזרה בכותרת הראשית של פריוריטי).',
    single_autofill_rule_help:
        'הגדירו חוקים למילוי אוטומטי של נתונים בשדות בהתאם לתנאים שתקבעו מראש. בצד הימני "אם" מגדירים את תנאי החוק. בצד השמאלי "אז" מגדירים את הערך שיתמלא בשדה כאשר מתקיימים תנאי החוק. דוגמה - אם בהזמנת לקוח משתמש רשם לקוח מסוים, השדה "פרטים" יתמלא אוטומטית בפרטים שהוגדרו ללקוח זה. מידע נוסף נמצא במדריך לממשק משתמש (תחת אייקון העזרה בכותרת הראשית של פריוריטי).',
    single_business_rule_help:
        'הגדירו פעולות אוטומטיות שיתבצעו בהתאם לתנאים שתקבעו מראש. בצד ימין "אם" מגדירים את תנאי החוק. בצד שמאל "אז" מגדירים את הפעולה שתתבצע כשמתקיימים תנאי החוק (למשל, הצגת הודעת שגיאה או אזהרה, שליחת אימייל או הודעת פוש למובייל ועוד). לדוגמה, נציג הודעת אזהרה כשבהזמנת  לקוח רושמים בשדה "אחוז הנחה" מספר הגדול מהמספר שתגדירו. עוד מידע על חוקים עסקיים נמצא במדריך לממשק משתמש (תחת אייקון העזרה בכותרת הראשית של פריוריטי).',
    single_rule_active_label: 'פעיל',
    rule_dd_placeholder: 'בחרו',
    condition_if_label: 'אם',
    condition_of_label: 'בשדה',
    autofill_source_field: 'לאחר עדכון בשדה',
    autofill_condition_set: 'Set in the field',
    autofill_condition_as: 'ערך',
    condition_function_label: 'פעולה',
    condition_value_label: 'ערך',
    function_dialog_help:
        'הוסיפו ביטויים או פעולות לתנאים שבחוק. במקום ערכים קבועים, אפשר להוסיף שדות ופעולות לביטוי וביטויים מוגדרים מראש. עוד מידע נמצא במדריך לממשק משתמש (תחת אייקון העזרה בכותרת הראשית של פריוריטי).',
    function_dialog_title: 'ביטוי',
    function_dialog_input_placeholder: 'הוסיפו שדה, פעולה, או ביטוי מוגדר מראש',
    function_dialog_tab_fields_label: 'שדות',
    function_dialog_tab_function_label: 'פעולה',
    function_icon_tooltip: 'הוספת ביטוי',
    function_dialog_tab_predefinedEpx_label: 'ביטוי מוגדר מראש',
    operator_and_label: 'ו',
    operator_or_label: 'או',
    input_field_label: 'שדה',
    input_message_label: 'הודעה',
    input_message_placeholder: 'כתיבת הודעה',
    input_subject_label: 'נושא',
    input_subject_placeholder: 'נושא הודעה',
    attachment_label: 'נספחים',
    documents_label: 'בחירת מסמך',
    print_format_label: 'לפי פורמט הדפסה',
    html_group_label: 'HTML',
    doc_group_label: 'מסמך',
    pdf_label: 'פורמט PDF',
    action_label: 'פעולה',
    new_autofill_rule_dialog_title: 'הגדרת חוק למילוי אוטומטי',
    apply_to_all_companies_label: 'בכל החברות',
    cancel_btn_label: 'ביטול',
    add_new_condition_label: 'הוספת תנאי',
    select_placeholder: '…בחירה',
    exit_without_saving_msg: 'החוק עדיין לא נשמר. לצאת בכל זאת?',
    attach_as_template_label: 'Template Document?',
    show_more_label: 'לראות עוד',
    show_less_label: 'לראות פחות',
    send_to_label: 'שליחה אל',
    assign_to_label: 'לטיפול',
    value_changes_label: 'השתנה',
    in_label: 'בשדה',
    if_optional_label: 'בתנאי ש (אופציונלי)',
    wrong_exp_title: 'שגיאה בהוספת ביטוי',
    no_options_text: 'אין תוצאות',
    ignoreCase: 'לכלול אותיות רישיות וקטנות',
    search_from_start: 'חיפוש מתחילת רשומה',
    wrong_exp_text: 'הביטוי אינו תקין.',
    only_label: 'עבור',
    select_user_placeholder: 'Select user...',
    select_group_placeholder: 'Select group...',
    general_choose_placeholder: 'בחירה',
    rule_dialog_save: 'אישור',
    delete_rule_title: 'מחיקה',
    delete_rule_text: 'האם למחוק את החוק?',
    delete_rule_confirm_label: 'כן',
    delete_rule_decline_label: 'לא',
    email_field_placeholder: 'לאיזה אימייל לשלוח?',
    email_field_label: 'כתובת אימייל',
    add_email_label: 'הוספה',
    email_validation_error: 'הכניסו כתובת אימייל תקינה',
    old_email_template_label: 'כתיבה',
    new_email_template_label: 'עריכת אימייל',
    autofill_card_field_label: '',
    user_verification_content:
        'כאן תוכלו לקבוע שכשמתקיים צירוף תנאים, תתקבל הודעה הדורשת את אימות המשתמש. כך תוכלו לוודא שמי שביצע את הפעולה, הוא אכן המשתמש המורשה לכך.',
    english_lang_tab: 'אנגלית',
    hebrew_lang_tab: 'עברית',
    business_rule_error_title: 'חוק עסקי',
    add_document: 'צירוף מסמך',
    go_back_dialog_title: 'רגע לפני היציאה',
    go_back_dialog_content: 'החוק עדיין לא נשמר. לצאת בכל זאת?',
    go_back_dialog_secondary_btn: 'ביטול',
    go_back_dialog_primary_btn: 'אישור',
    go_back_btn_tooltip: 'חזרה לרשימה',
    general_automation_list_dialog_help:
        'הגדירו חוקים לייעול תהליכי העבוד כאן תוכלו לצפות ברשימת החוקים ולנהל אותם. אתרו חוק במהירות באמצעות סינון או חיפוש. אפשר לערוך, להעתיק או למחוק חוקים בקלות. לחצו על הכפתור "חדש" כדי להתחיל. עוד מידע על חוקים למילוי אוטומטי נמצא במדריך לממשק משתמש (תחת אייקון העזרה בכותרת הראשית של פריוריטי).',
    falls_between_and_operator_label: 'ל',
    save_business_rule_btn_validation_tooltip: 'כדי לשמור צריך למלא את כל שדות החובה',
    save_autofill_rule_btn_validation_tooltip: 'כדי לשמור צריך למלא את כל שדות החובה',
    save_rule_valid_for_user_error: 'משתמש שהחוק יהיה תקף עבורו',
    save_rule_valid_for_group_error: 'בחרו קבוצת הרשאות שהחוק יהיה תקף עבורה',
    help_popover_title: 'עזרה',
    date_control_custom_label: 'תאריך מסויים',
    date_control_placeholder: 'בחר תאריך'
};
export const mapping = {
    1: 'menu_trigger',
    2: 'menu_macro',
    3: 'menu_deleteMessage',
    4: 'menu_deleteYes',
    5: 'menu_deleteNo',
    6: 'menu_subMenuBottomTitle',
    7: 'menu_recordMacro',
    8: 'msg_startRecursiveMacro',
    10: 'dlg_yes',
    11: 'dlg_no',
    12: 'footer_recordingTooltip',
    13: 'footer_stopTooltip',
    14: 'dlg_title',
    15: 'dlg_inputNamePlaceholder',
    16: 'dlg_repeatTitle',
    17: 'dlg_help',
    18: 'dlg_repeatOptionNoRepeat',
    19: 'dlg_repeatOptionAll',
    20: 'dlg_repeatOptionConst',
    21: 'dlg_repeatOptionTimes',
    22: 'dlg_constOptionearnMsgContent',
    23: 'dlg_constOptionearnMsgBtn',
    24: 'dlg_footerSave',
    25: 'dlg_footerSaveExecute',
    26: 'dlg_saveSuccessMsg',
    27: 'dlg_unsavedMsgContent',
    28: 'dlg_unsavedMsgYesBtn',
    29: 'dlg_unsavedMsgNoBtn',
    30: 'dlg_editMacroTitle',
    31: 'menu_macroHelp',
    32: 'dlg_inputNameLabel',
    33: 'dlg_inputKeyLabel',
    34: 'dlg_saveSuccessNoKey',
    35: 'dlg_sameKeyMessage',
    36: 'dlg_sameKeyMessage2',
    37: 'dlg_accept',
    38: 'dlg_saveBtn',
    39: 'dlg_macroSettings',
    41: 'saveMacroMsg',
    42: 'footer_stopMacroTooltip',
    43: 'footer_stopMacroMessage',
    44: 'footer_macroAciveToolip',
    45: 'dlg_nameExistMsgContent',
    46: 'dlg_nameExistMsgContentNoPremissions',
    47: 'business_rules_option_title',
    48: 'autofill_rules_option_title',
    49: 'business_rules_dialog_title',
    50: 'new_label',
    51: 'report_btn_label',
    52: 'search_placeholder',
    53: 'all_actions_label',
    54: 'error_action_title',
    55: 'send_email_action_title',
    56: 'send_text_action_title',
    57: 'open_task_action_title',
    58: 'send_notification_action_title',
    59: 'webhook_action_title',
    60: 'user_verification_action_title',
    61: 'valid_for_label',
    62: 'myself_label',
    63: 'all_users_label',
    64: 'specific_user_label',
    65: 'updated_by_label',
    66: 'active_label',
    67: 'inactive_label',
    68: 'applied_filters_label',
    69: 'dnd_label',
    70: 'when_label',
    71: 'show_more_label',
    72: 'then_label',
    73: 'rule_number_label',
    74: 'rule_description_label',
    75: 'rule_valid_for_label',
    76: 'edit_tooltip',
    77: 'duplicate_tooltip',
    78: 'delete_tooltip',
    79: 'empty_state_business_rule_title',
    80: 'empty_state_business_rule_text',
    81: 'empty_search_title',
    82: 'empty_search_text',
    83: 'rules_dialog_help',
    84: 'help_popover_title',
    85: 'single_rule_active_label',
    86: 'rule_dd_placeholder',
    87: 'condition_of_label',
    88: 'condition_value_label',
    89: 'function_icon_tooltip',
    91: 'function_dialog_title',
    92: 'function_dialog_input_placeholder',
    93: 'function_dialog_tab_fields_label',
    94: 'function_dialog_tab_predefinedEpx_label',
    95: 'go_back_dialog_secondary_btn',
    96: 'operator_and_label',
    97: 'operator_or_label',
    98: 'input_field_label',
    99: 'input_message_label',
    100: 'warning_action_title',
    101: 'input_subject_label',
    102: 'attachment_label',
    103: 'documents_label',
    104: 'general_choose_placeholder',
    105: 'print_format_label',
    107: 'only_label',
    108: 'specific_user_option_text',
    109: 'my_privilege_group_label',
    110: 'spec_privilege_group_label',
    111: 'apply_to_all_companies_label',
    112: 'rule_dialog_save',
    113: 'html_group_label',
    114: 'doc_group_label',
    115: 'is_active_tooltip',
    116: 'is_inactive_tooltip',
    117: 'assign_to_label',
    118: 'send_to_label',
    119: 'user_verification_content',
    120: 'show_less_label',
    121: 'delete_rule_text',
    122: 'go_back_dialog_content',
    123: 'add_new_condition_label',
    124: 'select_placeholder',
    125: 'action_label',
    126: 'input_subject_placeholder',
    127: 'input_message_placeholder',
    128: 'condition_if_label',
    129: 'no_options_text',
    130: 'wrong_exp_title',
    131: 'wrong_exp_text',
    132: 'english_lang_tab',
    133: 'hebrew_lang_tab',
    134: 'delete_rule_title',
    135: 'delete_rule_decline_label',
    136: 'delete_rule_confirm_label',
    137: 'add_document',
    138: 'pdf_label',
    139: 'valid_for_filter_user',
    140: 'valid_for_filter_privilege_group',
    141: 'email_field_label',
    142: 'email_field_placeholder',
    143: 'add_email_label',
    144: 'email_validation_error',
    147: 'new_autofill_rule_dialog_title',
    148: 'autofill_condition_set',
    149: 'autofill_rules_dialog_help',
    150: 'autofill_card_field_label',
    151: 'single_autofill_rule_help',
    152: 'autofill_source_field',
    153: 'if_optional_label',
    154: 'autofill_condition_as',
    155: 'function_dialog_tab_function_label',
    157: 'function_dialog_help',
    158: 'in_label',
    159: 'empty_state_autofill_rule_text',
    160: 'single_business_rule_help',
    161: 'save_autofill_rule_btn_validation_tooltip',
    162: 'save_business_rule_btn_validation_tooltip',
    163: 'empty_state_autofill_rule_title',
    164: 'go_back_btn_tooltip',
    165: 'go_back_dialog_title',
    166: 'go_back_dialog_primary_btn',
    167: 'rule_description_placeholder',
    168: 'general_automation_list_dialog_help',
    169: 'falls_between_and_operator_label',
    171: 'save_rule_valid_for_user_error',
    172: 'save_rule_valid_for_group_error'
};

const fallbacks = {
    en,
    he
};

export function getServerTexts() {
    return getTexts(entity, mapping);
}

// init texts fallbacks according to the user's locale
initTexts(entity, fallbacks);

export const texts = localization[entity] as typeof en;
